import { useEffect, useState } from "react";
import { Container, Option } from "./styles";

export const SelectOptionButtons = ({
  refreshOptionSelected,
  options,
  defaultOption = "",
  isSelectable,
  width,
  columnsDesktop = undefined,
  columnsMobile = undefined,
  ...rest
}) => {
  const [option, setOption] = useState(defaultOption);

  // keep internal state in sync with defaultOption changes
  useEffect(() => {
    setOption(defaultOption);
  }, [defaultOption]);

  // notify parent when selection changes
  useEffect(() => {
    if (isSelectable) {
      refreshOptionSelected(option);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option, isSelectable]);

  const isGrid = !!columnsDesktop;

  return (
    <Container $columnsDesktop={columnsDesktop} $columnsMobile={columnsMobile}>
      {options.map((value, index) => {
        const Icon = value.icon;
        const selected = isSelectable && option === value.key;
        return (
          <Option
            key={index}
            aria-label={isSelectable ? "selectable-options" : undefined}
            $btnWidth={width}
            $isGrid={isGrid}
            $isSelected={selected}
            disabled={selected}
            type="button"
            onClick={() => {
              if (isSelectable) {
                setOption(value.key);
              } else {
                // For non-selectable groups (e.g. +1, +10) trigger every click
                refreshOptionSelected(value.key);
              }
            }}
          >
            {Icon ? <Icon fontSize="small" /> : null}
            {value.title}
          </Option>
        );
      })}
    </Container>
  );
};
